export const ALL_STATES_KEY = '__all_states__';

export const normalizeText = value =>
  (value || '')
    .toString()
    .trim()
    .toLowerCase();

const getFeaturedValue = entity =>
  Boolean(entity?.featuredOnHomepage ?? entity?.featured ?? entity?.isFeatured);

const getSortOrderValue = entity => {
  const rawValue = entity?.sortOrder;
  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return Number.MAX_SAFE_INTEGER;
  }

  const parsed = Number(rawValue);
  return Number.isFinite(parsed) ? parsed : Number.MAX_SAFE_INTEGER;
};

export const compareByFeaturedAndSortOrder = (a, b) => {
  const featuredA = getFeaturedValue(a);
  const featuredB = getFeaturedValue(b);
  if (featuredA !== featuredB) {
    return featuredA ? -1 : 1;
  }

  const sortOrderA = getSortOrderValue(a);
  const sortOrderB = getSortOrderValue(b);
  if (sortOrderA !== sortOrderB) {
    return sortOrderA - sortOrderB;
  }

  const labelA = normalizeText(a?.name || a?.slug || a?.title);
  const labelB = normalizeText(b?.name || b?.slug || b?.title);
  return labelA.localeCompare(labelB);
};

export const getStateKey = state => {
  if (state?.id !== undefined && state?.id !== null) {
    return `id:${state.id}`;
  }

  const stateSlug = normalizeText(state?.slug);
  if (stateSlug) {
    return `slug:${stateSlug}`;
  }

  const stateName = normalizeText(state?.name);
  return stateName ? `name:${stateName}` : '';
};

export const matchesSelectedState = (selectedState, entityState) => {
  if (!selectedState || !entityState) {
    return false;
  }

  const selectedStateId =
    selectedState?.id !== null && selectedState?.id !== undefined ? String(selectedState.id) : null;
  const selectedStateSlug = normalizeText(selectedState?.slug);
  const selectedStateName = normalizeText(selectedState?.name);

  const entityStateId =
    entityState?.id !== null && entityState?.id !== undefined ? String(entityState.id) : null;
  const entityStateSlug = normalizeText(entityState?.slug);
  const entityStateName = normalizeText(entityState?.name);

  if (selectedStateId && entityStateId && selectedStateId === entityStateId) {
    return true;
  }

  if (selectedStateSlug && entityStateSlug && selectedStateSlug === entityStateSlug) {
    return true;
  }

  if (selectedStateName && entityStateName && selectedStateName === entityStateName) {
    return true;
  }

  return false;
};
